import router from "@/router/index";
import store from "@/store/index";

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    await store.dispatch("users/waitForUserLoaded");
    if (!store.getters["users/isAuthenticated"]) {
      next("auth");
    } else {
      next();
    }
  } else {
    next();
  }
});

router.beforeEach(async (to, from, next) => {
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  if (requiresAdmin) {
    await store.dispatch("users/waitForUserLoaded");
    if (!store.getters["users/isAdmin"]) {
      next("permission-denied");
    } else {
      next();
    }
  } else {
    next();
  }
});
